import { createReducer, on } from '@ngrx/store';
import { setAppSettings } from '../app.actions';

export interface AppSettingsState {
  [key: string]: string;
}

export const initialAppSettingsState: AppSettingsState = {};

export const appSettingsReducer = createReducer(
  initialAppSettingsState,

  on(setAppSettings, (_, action) => {
    return action.appSettings;
  })
);
